import RichText from '@/components/utilities/RichText';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import { resolveHeadingTag } from '@/utils/headings';

const H4 = ({ text, h4align, h4HtmlTag: htmlTag }) => {
  let classNameAlign = 'text-left';
  if (h4align === 'center') {
    classNameAlign = 'text-center mx-auto';
  } else if (h4align === 'right') {
    classNameAlign = 'text-right';
  }

  // Vzhled drží heading-4, úroveň si volí editor (bez volby zůstává <h4>).
  const Tag = resolveHeadingTag(htmlTag, 'h4');

  return (
    <VisibleLoading delay={100}>
      {({ ref, className }) => (
        <Tag ref={ref} className={`heading-4 xl:max-w-[820px] ${classNameAlign} ${className || ''}`.trim()}>
          <RichText>{text}</RichText>
        </Tag>
      )}
    </VisibleLoading>
  );
};
export default H4;
